import { createApp } from 'vue';
import VueCookies from 'vue-cookies';
import axios from 'axios';
if (process.env.NODE_ENV === 'production') {
    import('./registerServiceWorker');
}
import App from './App.vue';
import router from './router';
import { whatsAppNumber, wellKnownLogosOnly } from './config';
import { installDebugLog } from './utils/debugLog';
installDebugLog();
// Vuetify
import 'vuetify/styles';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
const vuetify = createVuetify({
    components,
    locale: {
        locale: 'en',
    },
    directives,
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        },
    },
});
const app = createApp(App);
app.config.globalProperties.$http = axios;
app.config.globalProperties.$whatsAppNumber = whatsAppNumber;
app.config.globalProperties.$wellKnownLogosOnly = wellKnownLogosOnly;
app.use(VueCookies);
app.use(router);
app.use(vuetify);
app.mount("#app");
